import { useEffect } from "react";
import { EtfStaticDataCard } from "./card";
import { EtfStaticDataNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { EtfStaticDataTable } from "./table";

export default function EtfStaticData() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Données statiques des ETF");
  }, []);

  return (
    <Routes>
      <Route index element={<EtfStaticDataTable />} />
      <Route path="/new" element={<EtfStaticDataNew />} />
      <Route path=":id" element={<EtfStaticDataCard />} />
    </Routes>
  );
}
